import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { putRequest } from '../../../requestUtils';

class ProjectFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isReadingMore: false,
      showReadMore: false,
      edit: false,
      note: props.note,
    };
    this.readMore = this.readMore.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount() {
    this.setShowReadMore();
  }

  handleEdit() {
    const { edit } = this.state;
    this.setState({ edit: !edit });
  }

  handleInputChange(event) {
    const { target } = event;
    this.setState({ note: target.value });
  }

  handleSubmit() {
    const { note } = this.state;
    const {
      resourceId, csrfToken, handleUpdateFeedback, feedback,
    } = this.props;
    putRequest(
      `/projects/${resourceId}/project_feedbacks/${feedback.id}`,
      { project_feedback: { note } },
      csrfToken,
    ).then(() => {
      this.setState({ edit: false, note });
      handleUpdateFeedback(feedback, note);
      this.setShowReadMore();
    });
  }

  handleCancel() {
    this.setState({ edit: false });
  }

  readMore() {
    this.setState({ isReadingMore: !this.state.isReadingMore });
  }

  renderEdit(feedback, canEdit) {
    if (canEdit) {
      return (
        <span className="pull-right body-text-3">
          <a
            tabIndex={0}
            role="button"
            onClick={this.handleEdit}
          >
            Edit
          </a>
        </span>
      );
    }
    return null;
  }

  renderNote() {
    const { isReadingMore, edit, note } = this.state;
    const { feedback } = this.props;
    if (edit) {
      return (
        <form>
          <div className="fs-hide form-group">
            <textarea
              value={note}
              className="form-control note body-text-3"
              placeholder="Add a comment..."
              name="note"
              id="edit-note"
              rows="3"
              onChange={(e) => this.handleInputChange(e)}
            />
          </div>
          <div className="align mb-2">
            <button
              className="btn btn-secondary-no-border end cancel-project-comment-update"
              type="button"
              onClick={() => this.handleCancel()}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary end update-project-comment ms-3"
              type="button"
              onClick={() => this.handleSubmit()}
            >
              Update
            </button>
          </div>
        </form>
      );
    }
    return (
      <div>
        <div
          ref={(el) => { this.notesElement = el; }}
          className={`comment ${isReadingMore ? 'show' : 'overflow'}`}
        >
          {feedback.note}
        </div>
        {this.renderDateAndReadMore()}
      </div>
    );
  }

  renderDateAndReadMore() {
    const { isReadingMore, showReadMore, edit } = this.state;
    const { feedback } = this.props;
    if (feedback.note && showReadMore && !edit) {
      return (
        <div className="align">
          <a
            className="body-text-4"
            tabIndex={0}
            role="link"
            onClick={this.readMore}
          >
            {' '}
            {isReadingMore ? 'Read Less' : 'Read More'}
          </a>
          <span className="body-text-4 end no-wrap muted-gray-text">
            {feedback.string_note_created_at}
          </span>
        </div>
      );
    }
    return (
      <div className="align">
        <span className="body-text-4 end no-wrap muted-gray-text">
          {feedback.string_note_created_at}
        </span>
      </div>
    );
  }

  setShowReadMore() {
    // Added 1 to clientHeight because in Safari 12.1 there is a rounding error leading
    // scrollHeight to be bigger than the clientHeight by 1 and so showReadMore is true
    this.setState({
      showReadMore: this.notesElement.scrollHeight > this.notesElement.clientHeight + 1,
    });
  }

  render() {
    const {
      feedback, displayName, canEdit, email,
    } = this.props;
    const identifier = feedback.name || feedback.email;

    return (
      <div className="feedback project-feedback body-text-3">
        <span className="fs-hide demibold body-text-3">
          {(displayName || canEdit) && (email === feedback.email ? 'You' : identifier)}
        </span>
        {this.renderEdit(feedback, canEdit)}
        {this.renderNote()}
      </div>
    );
  }
}

ProjectFeedback.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired,
  feedback: PropTypes.shape({
    string_note_created_at: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  handleUpdateFeedback: PropTypes.func.isRequired,
  note: PropTypes.string.isRequired,
  displayName: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
};

export default ProjectFeedback;
